import { useContext } from 'react';

import { openModal } from 'utils/modal';
import { markAsFound } from 'services/ops-control';
import { OpsControl } from 'contexts/ops-control.context';
import { FOUND_IT } from 'constants/lost-or-damaged';

import ProofModal from '../ProofModal';
import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as Eye } from 'assets/bosta-icons/Eye.svg';

import './ProofModalTrigger.less';

export const ProofModalTrigger = ({ delivery, fromFleet, fromHub }) => {
  const { allHubs } = useContext(OpsControl);

  const openProofModal = () => {
    openModal(ProofModal, {
      allHubs,
      delivery,
      fromFleet,
      fromHub,
      modalType: FOUND_IT,
      confirmEndPoint: markAsFound
    });
  };

  return (
    <BRButton
      type={'outline'}
      className={'br-lost-orders__proof-modal-trigger'}
      label={'View Proof'}
      onClick={openProofModal}
      prefixIcon={<Eye />}
    />
  );
};
